// src/components/GoogleMapEmbedComponent.js
import React from "react";
import "./Map.css"; // Ensure you import your CSS file

const GoogleMapEmbedComponent = () => {
  return (
    <div>
      <h2 style={{ textAlign: "center", margin: "20px 0" }}>
        JEE Vision Location
      </h2>{" "}
      {/* Title with margin */}
      <div className="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4895.248239460567!2d87.47518893977035!3d25.76953004876167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eff96d0a3b7393%3A0x360c3f4ee985c04d!2sJee%20Vision!5e0!3m2!1sen!2sin!4v1721708955259!5m2!1sen!2sin"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Map of JEE Vision Location"
        ></iframe>
      </div>
    </div>
  );
};

export default GoogleMapEmbedComponent;
